<template>
  <div class="navbar">
    <span v-for="(menuOption, iconKey) in this.icon"
      :class="getSelectedClass(iconKey)"
      v-on:click="changeMenu('iconKey')"
      :key="iconKey">
      <font-awesome-icon
        class="icon"
        :icon="menuOption"/>
    </span>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faTachometer,
  faStickyNote,
  faTrophy,
  faUser
} from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'XugarMenu',
  components: {
    FontAwesomeIcon
  },
  props: {
    selectedMenu: ''
  },
  data () {
    return {
      icon: {
        tachometer: faTachometer,
        note: faStickyNote,
        trophy: faTrophy,
        user: faUser
      },
      menuList: {
        tachometer: 'XugarStatus',
        note: '',
        trophy: '',
        user: ''
      }
    };
  },
  methods: {
    getSelectedClass (iconKey) {
      return this.selectedMenu === this.menuList[iconKey] ? 'selected' : '';
    },
    changeMenu (iconKey) {
      // this.selectedMenu = this.menuList[iconKey];
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables";

  .navbar {
    position: absolute;
    width: 100%;
    bottom: 0;
    background-color: #DB5044;
    height: 10%;
    display: flex;
  }
  .navbar span {
    float: left;
    display: block;
    color: $white-trans3;
    font-size: $fs-2xl;
    text-align: center;
    width: 25%;
    height: $sp-margin-larger;
    align-self: center;
    display: flex;
  }

  .icon {
    align-self: center;
    margin-left: auto;
    margin-right: auto;
  }

  span.selected {
    color: $white;
  }
</style>



// WEBPACK FOOTER //
// src/brand/xugarhero/components/XugarMenu.vue